var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { fuelSupplierSnapshotLabel } from '../fuelPrice/legSelection';
export const OPS_TIMEZONE = 'Europe/Prague';
export function toOperativeLegContent(data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        cancelled: data.cancelled,
        departureLocation: data.departureLocation,
        arrivalLocation: data.arrivalLocation,
        dateFrom: data.dateFrom,
        dateTo: data.dateTo,
        alternateAirports: [...data.alternateAirports].sort(),
        aircraftId: data.aircraftId,
        registration: data.registration,
        aircraftType: data.aircraftType,
        picResourceId: (_a = data.pic) === null || _a === void 0 ? void 0 : _a.resourceId,
        foResourceId: (_b = data.fo) === null || _b === void 0 ? void 0 : _b.resourceId,
        paxCount: data.paxCount,
        paxMale: (_c = data.paxMale) !== null && _c !== void 0 ? _c : 0,
        paxFemale: (_d = data.paxFemale) !== null && _d !== void 0 ? _d : 0,
        paxChild: (_e = data.paxChild) !== null && _e !== void 0 ? _e : 0,
        cargo: (_f = data.cargo) !== null && _f !== void 0 ? _f : 0,
        pets: (_g = data.pets) !== null && _g !== void 0 ? _g : false,
        fuelUplift: data.fuelUplift,
        fuelAirport: data.fuelAirport,
        handlingDepartureProviderId: data.handlingDepartureProviderId,
        handlingArrivalProviderId: data.handlingArrivalProviderId,
        cateringDepartureProviderId: data.cateringDepartureProviderId,
        cateringArrivalProviderId: data.cateringArrivalProviderId,
        services: [...((_h = data.services) !== null && _h !== void 0 ? _h : [])].sort(),
        departureServices: [...((_j = data.departureServices) !== null && _j !== void 0 ? _j : [])].sort(),
        arrivalServices: [...((_k = data.arrivalServices) !== null && _k !== void 0 ? _k : [])].sort(),
        fuelSupplier: data.fuelSupplier,
    };
}
export function storedLegChanges(changes) {
    return changes.map((_a) => {
        var { message: _message } = _a, stored = __rest(_a, ["message"]);
        return stored;
    });
}
export function legChangeText(change) {
    return change.kind === 'removed' ? change.text : withoutLegLabel(change.text);
}
const SERVICE_LABELS = {
    boardToBoardService: 'board-to-board',
    catering: 'catering',
    fuelAvgasAvailable: 'AVGAS',
    fuelJetAvailable: 'JET fuel',
    immigrationCustomsAvailable: 'customs & immigration',
    petsPermitRequired: 'pets permit',
    slotPprRequired: 'slot/PPR',
    taxi: 'taxi',
    vipTerminal: 'VIP terminal',
};
function serviceLabel(key) {
    var _a;
    return (_a = SERVICE_LABELS[key]) !== null && _a !== void 0 ? _a : key;
}
const CATERING_SERVICE = 'catering';
const SILENT_SERVICES = new Set(['slotPprRequired']);
function clockParts(iso, timeZone) {
    const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    });
    const out = {};
    for (const part of formatter.formatToParts(new Date(iso))) {
        out[part.type] = part.value;
    }
    return out;
}
export function legDay(data) {
    const { day, month, year } = clockParts(data.dateFrom, OPS_TIMEZONE);
    return `${Number(day)}.${Number(month)}.${year}`;
}
function utcTime(iso) {
    const { hour, minute } = clockParts(iso, 'UTC');
    return `${hour}${minute}`;
}
function legTimes(data) {
    return `${utcTime(data.dateFrom)}-${utcTime(data.dateTo)}`;
}
export function legLabel(data) {
    var _a, _b, _c;
    const route = `${(_a = data.departureLocation) !== null && _a !== void 0 ? _a : '?'}-${(_b = data.arrivalLocation) !== null && _b !== void 0 ? _b : '?'}`;
    return `${legDay(data)} ${(_c = data.registration) !== null && _c !== void 0 ? _c : '(no aircraft)'} ${route} ${legTimes(data)}`;
}
const LEG_LABEL_PATTERN = /\d{1,2}\.\d{1,2}\.\d{4} .+? \d{4}-\d{4}/;
export function withoutLegLabel(text) {
    const changed = new RegExp(`^Change ${LEG_LABEL_PATTERN.source} (.*)$`).exec(text);
    if (changed) {
        return changed[1];
    }
    return text.replace(new RegExp(` ${LEG_LABEL_PATTERN.source}`), '');
}
function paxText(data) {
    var _a, _b, _c;
    return `${data.paxCount} (${(_a = data.paxMale) !== null && _a !== void 0 ? _a : 0}/${(_b = data.paxFemale) !== null && _b !== void 0 ? _b : 0}/${(_c = data.paxChild) !== null && _c !== void 0 ? _c : 0})`;
}
export function describeLegChanges(previous, current, providerName = () => undefined) {
    var _a, _b, _c, _d, _e, _f;
    const before = toOperativeLegContent(previous);
    const after = toOperativeLegContent(current);
    const out = [];
    if (!before.cancelled && after.cancelled) {
        out.push({ field: 'cancelled', text: 'leg cancelled' });
    }
    if (before.cancelled && !after.cancelled) {
        out.push({ field: 'cancelled', text: 'leg reinstated' });
    }
    if (before.departureLocation !== after.departureLocation || before.arrivalLocation !== after.arrivalLocation) {
        out.push({
            field: 'route',
            text: `route changed to ${(_a = after.departureLocation) !== null && _a !== void 0 ? _a : '?'}-${(_b = after.arrivalLocation) !== null && _b !== void 0 ? _b : '?'}`,
        });
    }
    if (legDay(previous) !== legDay(current)) {
        out.push({ field: 'date', text: `date changed to ${legDay(current)}` });
    }
    if (utcTime(before.dateFrom) !== utcTime(after.dateFrom)) {
        out.push({ field: 'time', text: `departure time changed to ${utcTime(after.dateFrom)}Z` });
    }
    if (utcTime(before.dateTo) !== utcTime(after.dateTo)) {
        out.push({ field: 'time', text: `arrival time changed to ${utcTime(after.dateTo)}Z` });
    }
    if (before.registration !== after.registration || before.aircraftId !== after.aircraftId) {
        out.push({ field: 'aircraft', text: `aircraft changed to ${(_c = after.registration) !== null && _c !== void 0 ? _c : '(none)'}` });
    }
    else if (before.aircraftType !== after.aircraftType) {
        out.push({ field: 'aircraft', text: `aircraft type changed to ${(_d = after.aircraftType) !== null && _d !== void 0 ? _d : '(none)'}` });
    }
    if (before.picResourceId !== after.picResourceId) {
        out.push({ field: 'pic', text: crewText('PIC', (_e = current.pic) === null || _e === void 0 ? void 0 : _e.name, after.picResourceId) });
    }
    if (before.foResourceId !== after.foResourceId) {
        out.push({ field: 'fo', text: crewText('F/O', (_f = current.fo) === null || _f === void 0 ? void 0 : _f.name, after.foResourceId) });
    }
    if (before.paxCount !== after.paxCount ||
        before.paxMale !== after.paxMale ||
        before.paxFemale !== after.paxFemale ||
        before.paxChild !== after.paxChild) {
        out.push({ field: 'pax', text: `passenger number change to ${paxText(current)}` });
    }
    if (previous.cargo !== undefined && before.cargo !== after.cargo) {
        out.push({ field: 'cargo', text: `cargo change to ${after.cargo}kg` });
    }
    if (previous.pets !== undefined && before.pets !== after.pets) {
        out.push({ field: 'pets', text: after.pets ? 'pets on board' : 'no pets on board' });
    }
    if (Boolean(before.fuelAirport) !== Boolean(after.fuelAirport)) {
        out.push({
            field: 'fuelAirport',
            text: after.fuelAirport
                ? `fuel uplift airport changed to ${after.fuelAirport}`
                : 'fuel uplift airport removed',
        });
    }
    out.push(...describeFuelSupplierChange(before, after));
    out.push(...describeServiceChanges(previous, current, providerName));
    return out;
}
function describeFuelSupplierChange(before, after) {
    var _a;
    const was = before.fuelSupplier;
    const now = after.fuelSupplier;
    if (was === undefined || now === undefined) {
        return [];
    }
    if ((was === null || was === void 0 ? void 0 : was.provider) === (now === null || now === void 0 ? void 0 : now.provider) && ((was === null || was === void 0 ? void 0 : was.supplier) === (now === null || now === void 0 ? void 0 : now.supplier) || (was != null && was.supplier == null))) {
        return [];
    }
    const where = (_a = after.departureLocation) !== null && _a !== void 0 ? _a : '?';
    if (now == null) {
        return [{ field: 'fuelSupplier', standalone: true, text: `${where} fuel supplier removed.` }];
    }
    return [{ field: 'fuelSupplier', standalone: true, text: `${where} fuel supplier changed to ${fuelSupplierSnapshotLabel(now)}.` }];
}
function describeServiceChanges(previous, current, providerName) {
    const before = toOperativeLegContent(previous);
    const after = toOperativeLegContent(current);
    const out = [];
    if (before.handlingDepartureProviderId !== after.handlingDepartureProviderId) {
        out.push(handlingChange('handlingDeparture', after.departureLocation, after.handlingDepartureProviderId, providerName));
    }
    if (before.handlingArrivalProviderId !== after.handlingArrivalProviderId) {
        out.push(handlingChange('handlingArrival', after.arrivalLocation, after.handlingArrivalProviderId, providerName));
    }
    out.push(...describeCateringSupplierChanges(previous, current, providerName));
    const directional = hasDirectionalServices(previous) && hasDirectionalServices(current);
    if (!directional) {
        for (const change of diffServices(before.services, after.services)) {
            out.push({ field: `service:${change.key}`, text: `${serviceLabel(change.key)} ${change.verb}` });
        }
        return out;
    }
    for (const [direction, icao, from, to] of [
        ['departure', after.departureLocation, before.departureServices, after.departureServices],
        ['arrival', after.arrivalLocation, before.arrivalServices, after.arrivalServices],
    ]) {
        for (const change of diffServices(from, to)) {
            out.push({
                field: `service:${direction}:${change.key}`,
                standalone: true,
                text: `${icao !== null && icao !== void 0 ? icao : '?'} ${serviceLabel(change.key)} service${change.verb === 'added' ? '' : ' removed'}.`,
            });
        }
    }
    return out;
}
function describeCateringSupplierChanges(previous, current, providerName) {
    const before = toOperativeLegContent(previous);
    const after = toOperativeLegContent(current);
    return [
        ['cateringDeparture', after.departureLocation, 'departureServices'],
        ['cateringArrival', after.arrivalLocation, 'arrivalServices'],
    ]
        .map(([field, icao, services]) => {
        const key = `${field}ProviderId`;
        const was = before[key];
        const now = after[key];
        if (was === undefined || now === undefined || was === now) {
            return undefined;
        }
        if (!before[services].includes(CATERING_SERVICE) || !after[services].includes(CATERING_SERVICE)) {
            return undefined;
        }
        const where = icao !== null && icao !== void 0 ? icao : '?';
        if (!now) {
            return { field, standalone: true, text: `${where} catering supplier removed.` };
        }
        const name = providerName(now);
        return {
            field,
            standalone: true,
            text: `${where} catering supplier changed to ${name ? name.toUpperCase() : now}.`,
        };
    })
        .filter((change) => change !== undefined);
}
function hasDirectionalServices(data) {
    return Array.isArray(data.departureServices) && Array.isArray(data.arrivalServices);
}
function diffServices(before, after) {
    return [
        ...after.filter((s) => !before.includes(s)).map((key) => ({ key, verb: 'added' })),
        ...before.filter((s) => !after.includes(s)).map((key) => ({ key, verb: 'removed' })),
    ].filter((change) => !SILENT_SERVICES.has(change.key));
}
function handlingChange(field, icao, providerId, providerName) {
    const where = icao !== null && icao !== void 0 ? icao : '?';
    if (!providerId) {
        return { field, standalone: true, text: `${where} handling service removed.` };
    }
    const name = providerName(providerId);
    return {
        field,
        standalone: true,
        text: `${where} handling service changed to ${name ? name.toUpperCase() : providerId}.`,
    };
}
function crewText(role, name, resourceId) {
    if (!resourceId) {
        return `${role} removed`;
    }
    return `${role} changed to ${name || resourceId}`;
}
export function legChangeSentences(previous, current, providerName, standalone) {
    return describeLegChanges(previous, current, providerName).map((change) => {
        if (change.standalone) {
            return change.text;
        }
        return standalone ? `${change.text}.` : `Change ${legLabel(current)} ${change.text}.`;
    });
}
export function buildFlightOrderChanges(args) {
    const { previous, current, providerName } = args;
    const previousByLeg = new Map(previous.map((leg) => [leg.legId, leg]));
    const currentByLeg = new Map(current.map((leg) => [leg.legId, leg]));
    const out = [];
    for (const leg of previous) {
        if (!currentByLeg.has(leg.legId)) {
            const text = `Leg removed ${legLabel(leg)}.`;
            out.push({ fields: [], kind: 'removed', legId: leg.legId, message: text, text });
        }
    }
    for (const leg of current) {
        const before = previousByLeg.get(leg.legId);
        if (!before) {
            out.push({
                fields: [],
                kind: 'added',
                legId: leg.legId,
                message: `New leg added ${legLabel(leg)}.`,
                text: 'New leg added.',
            });
            continue;
        }
        const cancelled = leg.cancelled && !before.cancelled;
        for (const change of describeLegChanges(before, leg, providerName)) {
            out.push({
                fields: [change.field],
                kind: cancelled ? 'cancelled' : 'changed',
                legId: leg.legId,
                message: change.standalone ? change.text : `Change ${legLabel(leg)} ${change.text}.`,
                text: change.standalone ? change.text : `${change.text}.`,
            });
        }
    }
    return out.sort((a, b) => sortKey(a, previousByLeg, currentByLeg).localeCompare(sortKey(b, previousByLeg, currentByLeg)));
}
function sortKey(change, previousByLeg, currentByLeg) {
    var _a, _b;
    const data = (_a = currentByLeg.get(change.legId)) !== null && _a !== void 0 ? _a : previousByLeg.get(change.legId);
    return (_b = data === null || data === void 0 ? void 0 : data.dateFrom) !== null && _b !== void 0 ? _b : '';
}
export function changesHeadline(flightDay, cancelled) {
    const [, month, day] = flightDay.split('-');
    return `Your Flight order for ${Number(day)}.${Number(month)} has been ${cancelled ? 'cancelled' : 'changed'}:`;
}
export function pendingChangesText(pending, flightDay) {
    return [changesHeadline(flightDay, pending.cancelled), ...pending.changes.map((c) => { var _a; return (_a = c.message) !== null && _a !== void 0 ? _a : c.text; })].join(' ');
}
//# sourceMappingURL=legChanges.js.map